<template>
    <div class="centered vue-loader" style="height: calc(100vh - 150px)">
        <vue-loader></vue-loader>
    </div>
</template>

<script>
    import {LoaderIcon} from "vue-feather-icons";

    export default {
        name:'Loader',
        components: {VueLoader: LoaderIcon},
    }
</script>
